import React, { createContext, useCallback, useState, useRef, useEffect, } from "react";
export const UploadControllerContext = createContext({
    uploads: {},
    removeFile: () => { },
    addFile: () => { },
    errorText: null,
});
export const UploadControllerProvider = ({ children, uploadFile, onChanged, allow, initialValue }) => {
    const fileId = useRef(0);
    const incrementId = useCallback(() => ++fileId.current, [fileId]);
    const [errorText, setErrorText] = useState(null);
    const [uploads, setUploads] = useState(() => {
        const state = {};
        if (initialValue) {
            for (let file of initialValue) {
                state[incrementId()] = {
                    public_name: file.public_name,
                    key: file.key,
                    type: "success",
                    download_url: file.download_url,
                    storage_file: file,
                };
            }
        }
        return state;
    });
    const updateStatus = useCallback((id, status) => setUploads((uploads) => ({
        ...uploads,
        [id]: {
            public_name: uploads[id].public_name,
            ...status,
        },
    })), []);
    const isFileTypeAllowed = (fileType, allow) => {
        if (allow.includes("image/*") && fileType.startsWith("image/"))
            return true;
        if (allow.includes("video/*") && fileType.startsWith("video/"))
            return true;
        else
            return allow.includes(fileType);
    };
    const addFile = useCallback(async (file) => {
        if (!isFileTypeAllowed(file.type, allow)) {
            allow.includes("application/pdf")
                ? setErrorText(`You can upload only images, videos or PDFs`)
                : setErrorText("You can upload only images or videos");
            return;
        }
        else {
            setErrorText(null);
            const id = incrementId();
            setUploads((uploads) => ({
                ...uploads,
                [id]: {
                    public_name: file.name,
                    type: "loading",
                },
            }));
            try {
                const storageFile = await uploadFile(file);
                updateStatus(id, {
                    type: "success",
                    key: storageFile.key,
                    download_url: storageFile.download_url,
                    storage_file: storageFile,
                });
            }
            catch (e) {
                updateStatus(id, { type: "error", error: e });
            }
        }
    }, []);
    const removeFile = useCallback((id) => {
        setUploads((prev) => {
            const uploads = { ...prev };
            delete uploads[id];
            return uploads;
        });
    }, []);
    useEffect(() => {
        onChanged(Object.values(uploads));
    }, [uploads]);
    return (React.createElement(UploadControllerContext.Provider, { value: {
            uploads: uploads,
            addFile: addFile,
            removeFile: removeFile,
            errorText: errorText,
        } }, children));
};
//# sourceMappingURL=UploadControllerProvider.js.map